import * as tslib_1 from "tslib";
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Data, IWeightInfo, IFoodDesc } from './services/data';
import { FormBuilder } from '@angular/forms';
var FoodDetails = /** @class */ (function () {
    function FoodDetails(data, builder) {
        this.data = data;
        this.builder = builder;
        this.flatTransForm = function (node) {
            return node;
        };
        this.flatLevel = function (node) {
            return node.level;
        };
        this.flatExpandable = function (node) {
            return node.children.length > 0;
        };
        this.flatChildren = function (node) {
            return node.children;
        };
        this.tree = new FlatTreeControl(this.flatLevel, this.flatExpandable);
        this.flattener = new MatTreeFlattener(this.flatTransForm, this.flatLevel, this.flatExpandable, this.flatChildren);
        this.dataSource = new MatTreeFlatDataSource(this.tree, this.flattener);
        this.measurementOptions = [];
        this.selectedWeightId = -1;
    }
    FoodDetails.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.foodId)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.setup()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FoodDetails.prototype.ngOnChanges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.foodId)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.setup()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FoodDetails.prototype.setup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var food, info, weights;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.food && this.food.id === this.foodId)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.data.foodDetails(this.foodId)];
                    case 1:
                        food = _a.sent();
                        this.inputForm = this.builder.group({
                            measurement: 100,
                            measurementUnit: 'g',
                        });
                        this.food = food;
                        info = this.nutritionInfo();
                        return [4 /*yield*/, this.data.weights.where('foodDesId').equals(this.foodId).toArray()];
                    case 2:
                        weights = _a.sent();
                        this.measurementOptions = [{ measurementDesc: 'grams', amount: 100, grams: 100, foodDescId: this.foodId, seq: -1 }].concat(weights);
                        setTimeout(function () { return _this.dataSource.data = info; }, 10);
                        return [2 /*return*/];
                }
            });
        });
    };
    FoodDetails.prototype.nutritionInfo = function () {
        if (!this.food) {
            return [];
        }
        return [
            {
                value: "Calories: " + this.food.calories,
                level: 1,
                expandable: true,
                children: [{
                        value: "Carbs: " + this.food.carbs + " g",
                        level: 2,
                        expandable: true,
                        children: []
                    }, {
                        value: "Fat: " + this.food.fat + " g",
                        level: 2,
                        expandable: false,
                        children: []
                    }, {
                        value: "Protein: " + this.food.protein + " g",
                        level: 2,
                        expandable: false,
                        children: []
                    }],
            }
        ];
    };
    return FoodDetails;
}());
export { FoodDetails };
